import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useCallback, useMemo, useState } from "react";
import { ListSectionHeader } from "~/components/Shared/ListSectionHeader";
import { WKSPC_GALLERY_FIRST_SECTION_GAP_DESKTOP, WKSPC_GALLERY_FIRST_SECTION_GAP_MOBILE } from "~/constants/WorkspaceSpacing";
export const SECTIONS_DISTANCE = 64;
export const useGallerySectionHeader = (param)=>{
    let { isFirstSection, containerHeight, containerWidth, label, itemCount, containerPadding, onSectionCollapse, renderHeader } = param;
    const [isHeaderCollapsed, setHeaderCollapsed] = useState(false);
    const { isAboveMediumScreen } = useBreakpointsContext();
    const headerBox = useMemo(()=>({
            aspectRatio: 0,
            left: containerPadding,
            top: 0,
            width: containerWidth - containerPadding,
            height: containerHeight !== null && containerHeight !== void 0 ? containerHeight : isFirstSection ? !isAboveMediumScreen ? WKSPC_GALLERY_FIRST_SECTION_GAP_MOBILE : WKSPC_GALLERY_FIRST_SECTION_GAP_DESKTOP : SECTIONS_DISTANCE + 16
        }), [
        containerPadding,
        containerWidth,
        isFirstSection,
        isAboveMediumScreen,
        containerHeight
    ]);
    const onToggleCollapse = useCallback(()=>{
        setHeaderCollapsed((collapsed)=>{
            onSectionCollapse === null || onSectionCollapse === void 0 ? void 0 : onSectionCollapse(!collapsed);
            return !collapsed;
        });
    }, [
        onSectionCollapse
    ]);
    const render = useCallback(()=>{
        if (!!renderHeader) {
            return renderHeader({
                collapsed: isHeaderCollapsed,
                onToggleCollapse,
                label,
                itemCount
            });
        }
        return /*#__PURE__*/ _jsx(ListSectionHeader, {
            headerTitle: "".concat(label, " (").concat(itemCount === null || itemCount === void 0 ? void 0 : itemCount.toLocaleString(), ")"),
            collapsed: isHeaderCollapsed,
            onClick: onToggleCollapse
        });
    }, [
        isHeaderCollapsed,
        onToggleCollapse,
        renderHeader,
        label,
        itemCount
    ]);
    return {
        isHeaderCollapsed,
        header: {
            box: headerBox,
            render
        }
    };
};
